import React from "react";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import { InstallScreen } from "./InstallScreen";
import { Dashboard } from "./Dashboard";
import { ForgotPassword } from "components/ForgotPassword";
import { PasswordChange } from "components/PasswordChange";
import { PublicReferralForm } from "components/ReferralForm/PublicReferralForm";
import { EmbeddedForm } from "EmbeddedForm";
import { TermOfService } from "components/TermOfService";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Outlet />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/terms-of-service",
        element: <TermOfService />,
      },
      {
        path: "/embedded_form/:formCode",
        element: <EmbeddedForm />,
      },
      {
        path: "/embedded_form/:formCode/:defaultMode",
        element: <EmbeddedForm />,
      },
      {
        path: "form/:formCode",
        element: <PublicReferralForm />,
      },
      {
        path: "/install/:installToken",
        element: <InstallScreen />,
      },
      {
        path: "/forgot_password",
        element: <ForgotPassword />,
      },
      {
        path: "/password_change/:token",
        element: <PasswordChange />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export const AppRouter = () => <RouterProvider router={router} />;
